<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_693" data-name="Rectangle 693" width="155.993" height="179.946" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="Are_you_greenwashing_or_or_are_you_the_real_deal_" data-name="Are you greenwashing or or are
you the real deal?" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">Are you greenwashing or are</tspan>
        <tspan x="0" y="28">you the real deal?</tspan>
    </text>
    <text id="_The_pressure_is_mounting._Purpose_ESG_and_sustainability_are_increasingly_important_to_your_positioning._Make_sure_your_ideas_stand_up_to_the_test:_Can_we_do_it_better_than_the_competition_or_at_least_differently_"
          data-name="​​The pressure is mounting. Purpose, ESG and sustainability are increasingly important to your positioning. Make sure your ideas stand up to the test:

Can we do it better than the competition — or at
least differently?" transform="translate(40 121)" fill="#fff" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="23">​​The pressure is mounting.</tspan>
        <tspan x="0" y="51">Purpose, ESG and sustainability</tspan>
        <tspan x="0" y="79">are increasingly important to</tspan>
        <tspan x="0" y="107">your positioning. Make sure your</tspan>
        <tspan x="0" y="135">ideas stand up to the test:</tspan>
        <tspan x="0" y="163"></tspan>
        <tspan x="0" y="191">Can we do it better than the</tspan>
        <tspan x="0" y="219">competition — or at</tspan>
        <tspan x="0" y="247">least differently?</tspan>
    </text>
    <g id="Group_1359" data-name="Group 1359" transform="translate(116 404)">
        <rect id="Rectangle_692" data-name="Rectangle 692" width="35.657" height="35.657"
              transform="translate(73.239 34.044)" fill="none" stroke="#008ed2" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <g id="Group_1358" data-name="Group 1358">
            <g id="Group_1357" data-name="Group 1357" clip-path="url(#clip-path)">
                <path id="Path_14699" data-name="Path 14699" d="M38.7,1,17.468,70.5H60.556Z" fill="none"
                      stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14700" data-name="Path 14700"
                      d="M121.58,24.617c-.12-8.427,8.452-13.732,16.246-13.732,10,0,19.282,8.928,16.743,19.288-2.269,9.258-14.8,11.1-17.575,20.382a22.664,22.664,0,0,0-.64,6.434m1.083,3.98a3.866,3.866,0,0,1,3.848,3.782,3.935,3.935,0,0,1-2.344,3.7,3.775,3.775,0,0,1-5.255-3.53A3.854,3.854,0,0,1,137.437,60.969Z"
                      fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14701" data-name="Path 14701"
                      d="M139.562,137.4c-1.689-12.674-19.863-9.763-28.6-8.821C99.38,129.826,88,132.35,76.3,132.35c-20.985,0-44.721-18.3-59.841-31.2-4.238-3.618-24.881-23-10.341-26.248,2.25-.5,4.577.382,6.6,1.483,5.1,2.768,9.272,6.925,13.908,10.409C34.352,92.6,44.619,97.706,54.372,98.3c-3.978-7.037,1.4-14.837,9.863-14.837l20.045.613c4.913,0,8.62-1.182,13.305-2.537A60.733,60.733,0,0,1,115.6,78.711c14.094,0,27.511,8.391,32.212,22.08M54.408,98.2a11.4,11.4,0,0,0,9.555,5.786h0l38.267,1.64a3.758,3.758,0,0,0,1.453-.207"
                      fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <line id="Line_7877" data-name="Line 7877" y2="5.068" transform="translate(139.348 144.711)" fill="none"
                      stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Path_14702" data-name="Path 14702" d="M139.348,156.255c-.094,1.408-.282,22.691-.282,22.691"
                      fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </g>
    </g>
</svg>
